export default "__VITE_ASSET___vQwDWPn__"